export default {
	cihangban: '此航班',
	paifangliang: '排放量是為您選擇的座位級別中的1名乘客計算的',
	chengke: '旅客',
	quebaoziliaozhengque: '請確保所有資料正確',
	ruhetianxiechengke: '如何填寫旅客資料?',
	beizhu: '備註',
	chakanpiaojiaguize: '查看票價規則',
	shengyushijian: '尚餘 X 分鐘完成預訂',
	zongjie: '費用',
	shuifeifujia: '稅款及附加費',
	zonge: '總額',
	xingbie: '性别',
	nan: '男',
	nv: '女',
	xingshi: '姓氏',
	zhongjianming: '中间名',
	mingzi: '名字',
	lizi0: '例子:李',
	ruyou: '如有',
	lizi: '例子:SIU MENG',
	zhengjianleixing: '証件類型',
	qingxuanze: '請選擇',
	huzhaohaoma: '護照號碼',
	huzhao: '護照',
	qingshuru: '請輸入',
	huzhaoguojia: '護照國家地區',
	daoqiriqi: '護照有效期',
	chushengriqi: '出生日期',
	queren: '確認',
	chongzhi: '重置',
	quxiao: '取消',
	baocun: '保存',
	shifouchangke: '是否飛行常客會員？',
	lianluoren: '聯絡人資料',
	dianyoudizhi: '電郵地址',
	zhengquedianyoudizhi: '正確的電郵地址',
	lianluodianhua: '聯絡電話',
	qingshurudianhua: '電話號碼',
	guojia: '國家',
	piaohao: '票號',
	wanchengyuding: '完成你的預訂',
	wancheng: '完成',
	fukuanxijie: '付款細節',
	shuikuanfujiafei: '含稅款及附加費',
	woyiyueduotiaokuan: '本人已經細閱及同意條款與細則',
	woyiyueduo: '本人已經細閱及同意',
	baocunxiangxixinxi: '在此處保存詳細資訊以自動填寫表格，以便日後預訂班機。',
	xiayibu: '下一步',
	fanhui: '返回',
	xuanzezuowei: '請選擇座位',
	ewaituibu: '額外腿部空間',
	shouxuan: '首選',
	biaozhun: '標準',
	yixuan: '已選',
	shangwu: '商務',
	jingji: '經濟',
	meiyouxuanwei: '沒有選位',
	xuanzezhong: '選擇中',
	xiagehangban: '下個航班',
	chuangjiandingdan: '創建訂單',
	chengkeanzhengjian:
		'所有頭銜和乘客姓名必須完全按照護照或其他有效旅行證件上的顯示輸入。 交易成功完成後，不允許修改所有權或乘客姓名。',
	shurudianziyoujian: '请输入接收确认的电子邮件地址。',
	hangbanbiangengshouyueshu: '班機變更受選定航空公司條款和條件的約束。',
	yudingzhongguanli:
		'您仍然可以在“我的預訂”中更改*並管理您的班機預訂。 然而，請注意，對已確認預訂的任何修改都將收取更改費，超過新購買的費用',
	cuxiaopiaojiabu: '促銷票價可能不允許更改。',
	chakanlvxingjianyi: '請查看您旅行行程中的旅行建議和運輸條款和條件，瞭解允許的更改。'
};
